import { DateTime } from "luxon";

const FEATURE_POPUP_EXPIRATION_DAYS = 30;

const parseDateTime = (date: string | DateTime) =>
  typeof date === "string" ? DateTime.fromFormat(date, "MM/dd/yyyy") : date;

export const daysBeforeRemoval = (removalDate: DateTime | string) =>
  Math.ceil(parseDateTime(removalDate).diffNow().as("days"));

export const isPastRemoval = (removalDate: DateTime | string) => {
  const numDaysRemaining = daysBeforeRemoval(parseDateTime(removalDate));
  return numDaysRemaining <= 0;
};

export const isStaleFeaturePopup = (featureReleaseDate: DateTime | string) => {
  const deprecationDate = parseDateTime(featureReleaseDate).plus({
    days: FEATURE_POPUP_EXPIRATION_DAYS,
  });
  return isPastRemoval(deprecationDate);
};
